'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dialog = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Dialog, _Component);

  function Dialog() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Dialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Dialog.__proto__ || (0, _getPrototypeOf2.default)(Dialog)).call.apply(_ref, [this].concat(args))), _this), _this.onCancel = function (event) {
      if (event && event.preventDefault) event.preventDefault();
      _this.props.onCancel(event, null);
    }, _this.stopPropagate = function (event) {
      if (event && event.stopPropagation) event.stopPropagation();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Dialog, [{
    key: 'render',
    value: function render() {
      var _cx;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          isBasic = _props.isBasic,
          isStatic = _props.isStatic;

      var styles = require('./Dialog.scss');

      var classModifiers = (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, styles['root--static'], isStatic), (0, _defineProperty3.default)(_cx, className + '--static', className && isStatic), (0, _defineProperty3.default)(_cx, styles['root--basic'], isBasic), (0, _defineProperty3.default)(_cx, className + '--basic', className && isBasic), _cx));

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className, styles.root, classModifiers), onClick: this.onCancel },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(styles.dialog, (0, _defineProperty3.default)({}, className + '__dialog', className)) },
          _react2.default.createElement(
            'div',
            {
              className: (0, _classnames2.default)(styles.content, (0, _defineProperty3.default)({}, className + '__content', className)),
              onClick: this.stopPropagate
            },
            children
          )
        )
      );
    }
  }]);
  return Dialog;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.node,
  onCancel: _react.PropTypes.func.isRequired,
  isStatic: _react.PropTypes.bool,
  isBasic: _react.PropTypes.bool,
  animating: _react.PropTypes.bool,

  className: _react.PropTypes.string
}, _temp2);
exports.default = Dialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseModal/Dialog/Dialog.jsx
// module id = 1601
// module chunks = 0